"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
let ContactWithHeadersEntity = class ContactWithHeadersEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], ContactWithHeadersEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "company", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], ContactWithHeadersEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], ContactWithHeadersEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true })
], ContactWithHeadersEntity.prototype, "is_customer", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], ContactWithHeadersEntity.prototype, "is_supplier", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '4.2.0' })
], ContactWithHeadersEntity.prototype, "is_nosupplier", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], ContactWithHeadersEntity.prototype, "is_staff", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "notes", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], ContactWithHeadersEntity.prototype, "cis_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "utr", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "company_number", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "tax_reference", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "vat_number", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "verification_number", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ContactWithHeadersEntity.prototype, "reference", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '4.2.0' })
], ContactWithHeadersEntity.prototype, "cis_rate_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '4.2.0' })
], ContactWithHeadersEntity.prototype, "external_company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '4.2.0' })
], ContactWithHeadersEntity.prototype, "connection_status", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', minAppVersion: '4.2.0' })
], ContactWithHeadersEntity.prototype, "invitation_hash", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '6.8.0', defaultValue: false })
], ContactWithHeadersEntity.prototype, "optout", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', serverOnly: true })
], ContactWithHeadersEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], ContactWithHeadersEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, minAppVersion: '8.0.0' })
], ContactWithHeadersEntity.prototype, "accounting_reference", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, minAppVersion: '8.0.0' })
], ContactWithHeadersEntity.prototype, "sync_uuid", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, minAppVersion: '8.0.0' })
], ContactWithHeadersEntity.prototype, "synced_uuid", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '', minAppVersion: '8.1.0' })
], ContactWithHeadersEntity.prototype, "account_name", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true, minAppVersion: '8.4.0' })
], ContactWithHeadersEntity.prototype, "is_simple", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: null })
], ContactWithHeadersEntity.prototype, "contactId", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "ContactFirstName", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "ContactLastName", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: null })
], ContactWithHeadersEntity.prototype, "addressId", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], ContactWithHeadersEntity.prototype, "addressIsDefault", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], ContactWithHeadersEntity.prototype, "addressInvoice", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressCountry", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressState", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressCity", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressCounty", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressAddress1", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressAddress2", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: '' })
], ContactWithHeadersEntity.prototype, "addressPostcode", void 0);
ContactWithHeadersEntity = __decorate([
    entity_1.EntityDecorator
], ContactWithHeadersEntity);
exports.default = ContactWithHeadersEntity;
//# sourceMappingURL=../../../../src/models/contactWithHeaders/entity.js.map